/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FoundryRaceStrategyRouteImport } from './routes/foundry/race-strategy'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FoundryRaceStrategyRoute = FoundryRaceStrategyRouteImport.update({
  id: '/foundry/race-strategy',
  path: '/foundry/race-strategy',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/foundry/race-strategy': typeof FoundryRaceStrategyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/foundry/race-strategy': typeof FoundryRaceStrategyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/foundry/race-strategy': typeof FoundryRaceStrategyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/foundry/race-strategy'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/foundry/race-strategy'
  id: '__root__' | '/' | '/foundry/race-strategy'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FoundryRaceStrategyRoute: typeof FoundryRaceStrategyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/foundry/race-strategy': {
      id: '/foundry/race-strategy'
      path: '/foundry/race-strategy'
      fullPath: '/foundry/race-strategy'
      preLoaderRoute: typeof FoundryRaceStrategyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FoundryRaceStrategyRoute: FoundryRaceStrategyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
